const require_runtime = require('../_virtual/_rolldown/runtime.cjs');

//#region src/type/index.ts
var type_exports = /* @__PURE__ */ require_runtime.__exportAll({});

//#endregion
Object.defineProperty(exports, 'type_exports', {
  enumerable: true,
  get: function () {
    return type_exports;
  }
});
//# sourceMappingURL=index.cjs.map